const breakpoints = {
    sm:    '40em',
    md:    '52em',
    lg:    '64em',
    xl:    '80em',
    '2xl': '96em',
  }

export default breakpoints